export default __webpack_public_path__ + "static/media/tete44.83dc04be.png";